/**
 * Canonical helpers for song media payloads from Convex.
 * Resolved track URLs are on the song object from Convex queries; optional legacy `media` is supported.
 */

export const getSongMediaKey = (songOrQueueItem) => {
  if (!songOrQueueItem || typeof songOrQueueItem !== 'object') return null
  if (songOrQueueItem.songId != null) return String(songOrQueueItem.songId)
  const id = songOrQueueItem.id ?? songOrQueueItem._id ?? null
  return id != null ? String(id) : null
}

export const getSongMedia = (song) => {
  if (!song || typeof song !== 'object') return null
  if (song.media && typeof song.media === 'object') return song.media
  const audioUrl = song.audioUrl ?? null
  const vocalTrackUrl = song.vocalTrackUrl ?? null
  const accompanimentTrackUrl = song.accompanimentTrackUrl ?? null
  const drumsTrackUrl = song.drumsTrackUrl ?? null
  if (!audioUrl && !vocalTrackUrl && !accompanimentTrackUrl && !drumsTrackUrl) {
    return null
  }
  return { audioUrl, vocalTrackUrl, accompanimentTrackUrl, drumsTrackUrl }
}

export const getVocalTrackUrl = (song) => getSongMedia(song)?.vocalTrackUrl ?? null

export const getAccompanimentTrackUrl = (song) => getSongMedia(song)?.accompanimentTrackUrl ?? null

export const getDrumsTrackUrl = (song) => getSongMedia(song)?.drumsTrackUrl ?? null

export const getMainAudioUrl = (song) => getSongMedia(song)?.audioUrl ?? null

export const hasAnyPlayableMedia = (song) => {
  const media = getSongMedia(song)
  if (!media) return false
  return Boolean(
    (media.vocalTrackUrl && media.accompanimentTrackUrl) || media.audioUrl
  )
}
